"use client";
import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./../css/ServiceAccordion.css";

const ServiceAccordionItem = ({ title, order, children, isOpen, onClick }) => {
  return (
    <motion.div initial={false} transition={{ duration: 0.2 }}>
      <button onClick={onClick} className='custom-accordion-button'>
        <span className='accordion-title'>{title}</span>
        <span className='accordion-order'>{order}</span>
      </button>
      <hr style={{color:"red",border:"1px solid #2a333d"}} className="w-100"/>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className='accordion-content-wrapper'
          >
            <div className='accordion-content'>{children}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

const ServiceAccordion = ({ items, allowMultipleOpen = false }) => {
  const [openIndexes, setOpenIndexes] = useState([0]);

  const handleItemClick = (index) => {
    setOpenIndexes((prevIndexes) => {
      if (prevIndexes.includes(index)) {
        return prevIndexes.filter((i) => i !== index);
      } else {
        if (!allowMultipleOpen) {
          return [index];
        } else {
          return [...prevIndexes, index];
        }
      }
    });
  };

  return (
    <div className='accordion-container'>
      {items.map((item, index) => (
        <ServiceAccordionItem
          key={index}
          title={item.title}
          order={item.order}
          isOpen={openIndexes.includes(index)}
          onClick={() => handleItemClick(index)}
        >
          {item.content}
        </ServiceAccordionItem>
      ))}
    </div>
  );
};

export default ServiceAccordion;
